// Mock data for BREDA Solar Monitoring System

// Bihar Districts with Solar Sites
export const districts = [
  { id: 'patna', name: 'Patna', sites: 12, capacity: 150, todayGen: 780, pr: 78, cuf: 18.5, status: 'good' },
  { id: 'gaya', name: 'Gaya', sites: 8, capacity: 96, todayGen: 420, pr: 65, cuf: 16.2, status: 'moderate' },
  { id: 'muzaffarpur', name: 'Muzaffarpur', sites: 10, capacity: 120, todayGen: 540, pr: 72, cuf: 17.8, status: 'good' },
  { id: 'bhagalpur', name: 'Bhagalpur', sites: 6, capacity: 72, todayGen: 310, pr: 58, cuf: 14.5, status: 'poor' },
  { id: 'darbhanga', name: 'Darbhanga', sites: 7, capacity: 84, todayGen: 380, pr: 68, cuf: 15.9, status: 'moderate' },
];

// State-wide totals
export const stateData = {
  totalCapacity: 522,
  totalSites: 43,
  todayGeneration: 2430,
  monthlyCUF: 17.2,
  averagePR: 68.2,
  openTickets: 14,
};

// Sites data (expandable)
export const sites = [
  // Patna
  { id: 'PTN001', name: 'Collectorate Building', district: 'patna', capacity: 15, todayGen: 78, pr: 82, cuf: 19.2, status: 'active', contractor: 'SunTech Solutions', address: 'Collectorate, Patna', deviceStatus: 'online', lastSync: '2 mins ago' },
  { id: 'PTN002', name: 'District Hospital', district: 'patna', capacity: 12, todayGen: 62, pr: 76, cuf: 18.1, status: 'active', contractor: 'GreenPower Ltd', address: 'Hospital Road, Patna', deviceStatus: 'online', lastSync: '5 mins ago' },
  { id: 'PTN003', name: 'Polytechnic College', district: 'patna', capacity: 18, todayGen: 92, pr: 80, cuf: 18.9, status: 'active', contractor: 'SunTech Solutions', address: 'Bailey Road, Patna', deviceStatus: 'online', lastSync: '1 min ago' },
  { id: 'PTN004', name: 'Primary School Block A', district: 'patna', capacity: 10, todayGen: 51, pr: 75, cuf: 17.8, status: 'active', contractor: 'EcoSolar Pvt Ltd', address: 'Boring Road, Patna', deviceStatus: 'online', lastSync: '3 mins ago' },
  { id: 'PTN005', name: 'Municipality Office', district: 'patna', capacity: 14, todayGen: 45, pr: 48, cuf: 11.2, status: 'faulty', contractor: 'SunTech Solutions', address: 'Dak Bungalow Road, Patna', deviceStatus: 'offline', lastSync: '2 hours ago' },
  
  // Gaya
  { id: 'GYA001', name: 'DM Office', district: 'gaya', capacity: 12, todayGen: 58, pr: 72, cuf: 17.1, status: 'active', contractor: 'Bihar Solar Corp', address: 'Civil Lines, Gaya', deviceStatus: 'online', lastSync: '4 mins ago' },
  { id: 'GYA002', name: 'Railway Station Complex', district: 'gaya', capacity: 20, todayGen: 95, pr: 70, cuf: 16.8, status: 'active', contractor: 'GreenPower Ltd', address: 'Station Road, Gaya', deviceStatus: 'online', lastSync: '7 mins ago' },
  { id: 'GYA003', name: 'Government ITI', district: 'gaya', capacity: 10, todayGen: 48, pr: 68, cuf: 16.5, status: 'active', contractor: 'Bihar Solar Corp', address: 'ITI Campus, Gaya', deviceStatus: 'online', lastSync: '5 mins ago' },
  { id: 'GYA004', name: 'Community Health Center', district: 'gaya', capacity: 8, todayGen: 28, pr: 52, cuf: 12.3, status: 'faulty', contractor: 'EcoSolar Pvt Ltd', address: 'NH-83, Gaya', deviceStatus: 'offline', lastSync: '4 hours ago' },
  
  // Muzaffarpur
  { id: 'MUZ001', name: 'Collectorate Complex', district: 'muzaffarpur', capacity: 16, todayGen: 82, pr: 76, cuf: 18.2, status: 'active', contractor: 'SunTech Solutions', address: 'Collectorate, Muzaffarpur', deviceStatus: 'online', lastSync: '2 mins ago' },
  { id: 'MUZ002', name: 'Engineering College', district: 'muzaffarpur', capacity: 22, todayGen: 112, pr: 75, cuf: 17.9, status: 'active', contractor: 'GreenPower Ltd', address: 'College Road, Muzaffarpur', deviceStatus: 'online', lastSync: '3 mins ago' },
  { id: 'MUZ003', name: 'District Court', district: 'muzaffarpur', capacity: 12, todayGen: 61, pr: 74, cuf: 17.6, status: 'active', contractor: 'Bihar Solar Corp', address: 'Court Area, Muzaffarpur', deviceStatus: 'online', lastSync: '6 mins ago' },
  
  // Bhagalpur
  { id: 'BHA001', name: 'Municipal Corporation', district: 'bhagalpur', capacity: 14, todayGen: 55, pr: 58, cuf: 13.8, status: 'moderate', contractor: 'EcoSolar Pvt Ltd', address: 'Tilka Manjhi Road, Bhagalpur', deviceStatus: 'warning', lastSync: '15 mins ago' },
  { id: 'BHA002', name: 'Medical College', district: 'bhagalpur', capacity: 18, todayGen: 72, pr: 59, cuf: 14.1, status: 'moderate', contractor: 'GreenPower Ltd', address: 'Mayaganj, Bhagalpur', deviceStatus: 'online', lastSync: '8 mins ago' },
];

// Generation trends (7-day)
export const generationTrend = [
  { date: '2025-07-15', generation: 2150 },
  { date: '2025-07-16', generation: 2280 },
  { date: '2025-07-17', generation: 2320 },
  { date: '2025-07-18', generation: 2180 },
  { date: '2025-07-19', generation: 2410 },
  { date: '2025-07-20', generation: 2380 },
  { date: '2025-07-21', generation: 2430 },
];

// Monthly generation data
export const monthlyGeneration = [
  { month: 'Jan', generation: 58000, capacity: 522 },
  { month: 'Feb', generation: 62000, capacity: 522 },
  { month: 'Mar', generation: 68000, capacity: 522 },
  { month: 'Apr', generation: 72000, capacity: 522 },
  { month: 'May', generation: 75000, capacity: 522 },
  { month: 'Jun', generation: 71000, capacity: 522 },
  { month: 'Jul', generation: 48000, capacity: 522 },
];

// Alerts
export const alerts = [
  { id: 1, type: 'critical', message: 'PTN005 - Municipality Office: Device offline for 2 hours', site: 'PTN005', timestamp: '2025-07-21 14:30', district: 'patna' },
  { id: 2, type: 'critical', message: 'GYA004 - Community Health Center: No data received for 4 hours', site: 'GYA004', timestamp: '2025-07-21 12:15', district: 'gaya' },
  { id: 3, type: 'warning', message: 'BHA001 - Municipal Corporation: PR dropped to 58%', site: 'BHA001', timestamp: '2025-07-21 15:00', district: 'bhagalpur' },
  { id: 4, type: 'warning', message: 'BHA002 - Medical College: CUF below 15% threshold', site: 'BHA002', timestamp: '2025-07-21 14:45', district: 'bhagalpur' },
  { id: 5, type: 'info', message: 'System maintenance scheduled for 22-July-2025', site: null, timestamp: '2025-07-21 09:00', district: null },
];

// Complaints/Tickets
export const complaints = [
  { id: 'TKT001', category: 'Device Malfunction', site: 'PTN005', district: 'patna', description: 'RMS device not sending data', status: 'open', priority: 'high', createdAt: '2025-07-21 12:30', assignedTo: 'Tech Team A', sla: 'overdue' },
  { id: 'TKT002', category: 'Low Generation', site: 'GYA004', district: 'gaya', description: 'Generation significantly below expected', status: 'in-progress', priority: 'high', createdAt: '2025-07-21 08:15', assignedTo: 'Tech Team B', sla: 'on-time' },
  { id: 'TKT003', category: 'Maintenance Request', site: 'BHA001', district: 'bhagalpur', description: 'Panel cleaning required', status: 'open', priority: 'medium', createdAt: '2025-07-21 14:00', assignedTo: 'Maintenance Team', sla: 'on-time' },
  { id: 'TKT004', category: 'Consumer Complaint', site: 'MUZ002', district: 'muzaffarpur', description: 'Inverter noise issue reported', status: 'resolved', priority: 'low', createdAt: '2025-07-20 10:30', assignedTo: 'Tech Team A', sla: 'on-time', resolvedAt: '2025-07-21 11:00' },
  { id: 'TKT005', category: 'Data Sync Issue', site: 'PTN003', district: 'patna', description: 'Intermittent data transmission', status: 'in-progress', priority: 'medium', createdAt: '2025-07-20 16:45', assignedTo: 'Tech Team C', sla: 'on-time' },
];

// Preventive Maintenance Schedule
export const maintenanceSchedule = [
  { id: 'PM001', site: 'PTN001', district: 'patna', type: 'Panel Cleaning', scheduledDate: '2025-07-25', technician: 'Raj Kumar', status: 'scheduled' },
  { id: 'PM002', site: 'PTN002', district: 'patna', type: 'Inverter Inspection', scheduledDate: '2025-07-26', technician: 'Amit Singh', status: 'scheduled' },
  { id: 'PM003', site: 'GYA001', district: 'gaya', type: 'Complete System Check', scheduledDate: '2025-07-23', technician: 'Suresh Yadav', status: 'scheduled' },
  { id: 'PM004', site: 'MUZ001', district: 'muzaffarpur', type: 'Panel Cleaning', scheduledDate: '2025-07-22', technician: 'Vikram Das', status: 'upcoming' },
  { id: 'PM005', site: 'PTN004', district: 'patna', type: 'RMS Device Check', scheduledDate: '2025-07-20', technician: 'Raj Kumar', status: 'completed' },
];

// RMS Integration Health
export const rmsHealth = {
  apiUptime: 98.5,
  devicesConnected: 41,
  devicesTotal: 43,
  lastSyncSuccess: '2025-07-21 15:45',
  dataIngestionRate: '95%',
  syncErrors24h: 3,
};

// RMS Device Status
export const rmsDevices = [
  { siteId: 'PTN001', deviceId: 'RMS-PTN-001', status: 'online', lastData: '2 mins ago', dataPoints: 1440, syncErrors: 0 },
  { siteId: 'PTN002', deviceId: 'RMS-PTN-002', status: 'online', lastData: '5 mins ago', dataPoints: 1438, syncErrors: 0 },
  { siteId: 'PTN003', deviceId: 'RMS-PTN-003', status: 'online', lastData: '1 min ago', dataPoints: 1440, syncErrors: 2 },
  { siteId: 'PTN005', deviceId: 'RMS-PTN-005', status: 'offline', lastData: '2 hours ago', dataPoints: 1320, syncErrors: 15 },
  { siteId: 'GYA004', deviceId: 'RMS-GYA-004', status: 'offline', lastData: '4 hours ago', dataPoints: 1200, syncErrors: 22 },
];

// Contractors
export const contractors = [
  { id: 'CNT001', name: 'SunTech Solutions', sites: 8, contact: '+91 98765 43210', email: 'contact@suntech.com' },
  { id: 'CNT002', name: 'GreenPower Ltd', sites: 10, contact: '+91 98765 43211', email: 'info@greenpower.com' },
  { id: 'CNT003', name: 'Bihar Solar Corp', sites: 7, contact: '+91 98765 43212', email: 'support@biharsolar.com' },
  { id: 'CNT004', name: 'EcoSolar Pvt Ltd', sites: 6, contact: '+91 98765 43213', email: 'help@ecosolar.com' },
];

// Users (for display purposes)
export const users = [
  { id: 'USR001', name: 'Admin User', role: 'admin', email: 'admin@breda.gov.in' },
  { id: 'USR002', name: 'BREDA Officer', role: 'breda_user', email: 'officer@breda.gov.in' },
  { id: 'USR003', name: 'Contractor User', role: 'contractor', email: 'contractor@suntech.com' },
];

export const weatherData = {
  sites: [
    { id: 'PTN001', name: 'Collectorate Building', temperature: '32°C', condition: 'Partly Cloudy', wind: '12 km/h', humidity: '65%', irradiance: '750 W/m²' },
    { id: 'PTN002', name: 'District Hospital', temperature: '33°C', condition: 'Sunny', wind: '10 km/h', humidity: '62%', irradiance: '800 W/m²' },
    { id: 'GYA001', name: 'DM Office', temperature: '34°C', condition: 'Sunny', wind: '8 km/h', humidity: '58%', irradiance: '850 W/m²' },
  ],
  districts: [
    { id: 'patna', name: 'Patna', temperature: '33°C', condition: 'Sunny', wind: '10 km/h', humidity: '60%', irradiance: '800 W/m²' },
    { id: 'gaya', name: 'Gaya', temperature: '35°C', condition: 'Clear Sky', wind: '7 km/h', humidity: '55%', irradiance: '880 W/m²' },
    { id: 'muzaffarpur', name: 'Muzaffarpur', temperature: '32°C', condition: 'Partly Cloudy', wind: '13 km/h', humidity: '68%', irradiance: '720 W/m²' },
  ]
};
